import { EnvironmentContext } from "components/Environment/EnvironmentContext";
import Box from "ds/components/Box";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";

import { showEnvVariableFormDrawer } from "../../EnvVariablesDrawer/EnvVariablesFormDrawer";
import { showDeleteConfirmation } from "../../VariableDeleteConfirmation/VariableDeleteConfirmation";
import { VariableCellComponentProps } from "./types";

const EnvVariableActionsCell = ({ variable, context }: VariableCellComponentProps) => {
  const { onDelete, onUpdate } = useTypedContext(EnvironmentContext);
  const canBeEdited = !(variable.runtime || context);

  return (
    <Box>
      <DropdownMenuEllipsis tooltip="Environment variable actions">
        {canBeEdited ? (
          <>
            <DropdownMenuItem
              onAction={() =>
                showEnvVariableFormDrawer({ id: variable.id, variable, onSubmit: onUpdate })
              }
            >
              Edit variable
            </DropdownMenuItem>
            <DropdownMenuItem
              onAction={() => showDeleteConfirmation({ id: variable.id, onDelete })}
              danger
            >
              Delete
            </DropdownMenuItem>
          </>
        ) : (
          <DropdownMenuItem
            onAction={() =>
              showEnvVariableFormDrawer({ id: variable.id, variable, onSubmit: onUpdate })
            }
          >
            Override
          </DropdownMenuItem>
        )}
      </DropdownMenuEllipsis>
    </Box>
  );
};

export default EnvVariableActionsCell;
